import { FormInputValue } from '@src/domains/orders/core/form-inputs/types';

export const areAllFormInputsFilled = (collectedValues: FormInputValue[], totalFormInputs: number): boolean =>
  collectedValues.length === totalFormInputs;
